import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import MultiSelect from 'vue-multiselect';

@Component({
  components: {
    MultiSelect,
  },
})
export default class UserDetailsFilter extends Vue {
  @Prop({ required: true }) filter!: string;

  value: string[] = [];

  @Emit()
  filterChange(filter: string): void {
    this.$emit('filterChange', filter);
  }
}
